import React, { useState } from 'react';
interface Tab {
  id: string;
  label: string;
  count?: number;
}
interface TabsProps {
  tabs: Tab[];
  activeTab?: string;
  onChange?: (tabId: string) => void;
}
export function Tabs({
  tabs,
  activeTab,
  onChange
}: TabsProps) {
  const [active, setActive] = useState(activeTab || tabs[0]?.id);
  const handleChange = (tabId: string) => {
    setActive(tabId);
    onChange?.(tabId);
  };
  return <div className="border-b border-slate-200 dark:border-slate-800" data-id="element-653">
      <nav className="-mb-px flex gap-6" aria-label="Tabs" data-id="element-654">
        {tabs.map(tab => <button key={tab.id} onClick={() => handleChange(tab.id)} className={`
              py-3 px-1 text-sm font-medium border-b-2 transition-colors
              ${active === tab.id ? 'border-blue-600 text-blue-600 dark:text-blue-500 dark:border-blue-500' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300 dark:text-slate-400 dark:hover:text-slate-200 dark:hover:border-slate-700'}
            `} aria-current={active === tab.id ? 'page' : undefined} data-id="element-655">
            {tab.label}
            {tab.count !== undefined && <span className={`
                  ml-2 px-2 py-0.5 rounded-full text-xs
                  ${active === tab.id ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'}
                `} data-id="element-656">
                {tab.count}
              </span>}
          </button>)}
      </nav>
    </div>;
}